// extracted by mini-css-extract-plugin
export default {"form":"WorkInstructions_form__+LURB","button":"WorkInstructions_button__5SM36"};